export const OPEN_PREFERENCES_EVENT = 'sp:cookie-preferences-open';

export function openCookiePreferences(): void {
  try {
    window.dispatchEvent(new CustomEvent(OPEN_PREFERENCES_EVENT));
  } catch {
    // ignore
  }
}
